import React__default from 'react';
import { c as classnames } from '../../../../../index-f9fe84d4.js';
import '../../../../../_commonjsHelpers-1a7a244d.js';

var ColHeaderBlockInner = function (_a) {
    var children = _a.children, isLeft = _a.isLeft, _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, additionalRef = _a.additionalRef;
    var colHeaderBlockInnerClassNames = classnames('top-row-icon-block-inner', {
        left: isLeft,
        right: !isLeft,
    });
    return (React__default.createElement("div", { className: colHeaderBlockInnerClassNames, onClick: onClick, ref: additionalRef }, children));
};

export { ColHeaderBlockInner };
